/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteProjectDomainInput
 */
export interface DeleteProjectDomainInput {
    /**
     * 
     * @type {string}
     * @memberof DeleteProjectDomainInput
     */
    hostName?: string;
}

/**
 * Check if a given object implements the DeleteProjectDomainInput interface.
 */
export function instanceOfDeleteProjectDomainInput(value: object): value is DeleteProjectDomainInput {
    return true;
}

export function DeleteProjectDomainInputFromJSON(json: any): DeleteProjectDomainInput {
    return DeleteProjectDomainInputFromJSONTyped(json, false);
}

export function DeleteProjectDomainInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteProjectDomainInput {
    if (json == null) {
        return json;
    }
    return {
        
        'hostName': json['hostName'] == null ? undefined : json['hostName'],
    };
}

export function DeleteProjectDomainInputToJSON(json: any): DeleteProjectDomainInput {
    return DeleteProjectDomainInputToJSONTyped(json, false);
}

export function DeleteProjectDomainInputToJSONTyped(value?: DeleteProjectDomainInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostName': value['hostName'],
    };
}

